export default "__VITE_ASSET__CHX34wro__"